(function () {
  'use strict';

  function norm(value) {
    return (value || '').trim();
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function preferVariant(a, b) {
    if (!a) return b;
    if (!b) return a;
    var aAvail = a.availableForSale !== false;
    var bAvail = b.availableForSale !== false;
    if (aAvail !== bAvail) return aAvail ? a : b;
    var aHasImg = Boolean(a.bigImg || a.boxImg || a.flowerImg);
    var bHasImg = Boolean(b.bigImg || b.boxImg || b.flowerImg);
    if (aHasImg !== bHasImg) return aHasImg ? a : b;
    return a;
  }

  function inMasterOrder(byKeyMap, masterOrder) {
    var out = [];
    for (var i = 0; i < masterOrder.length; i++) {
      var v = byKeyMap.get(norm(masterOrder[i]));
      if (v) out.push(v);
    }
    return out;
  }

  // Shopify's {{amount}} already includes the thousands comma (e.g. "1,210.00");
  // {{amount_with_comma_separator}} is actually the European format (comma decimal,
  // period thousands), not "add a comma" like the name suggests.
  function withThousands(value, sep) {
    var parts = value.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, sep);
    return parts.join('.');
  }

  function formatMoney(amount, format) {
    var num = parseFloat(amount);
    if (isNaN(num)) return '';
    format = format || '${{amount}}';
    var twoDecimals = num.toFixed(2);
    var noDecimals = Math.round(num).toString();
    var replacements = {
      amount: withThousands(twoDecimals, ','),
      amount_no_decimals: withThousands(noDecimals, ','),
      amount_with_comma_separator: withThousands(twoDecimals, '.').replace(/\.(\d{2})$/, ',$1'),
      amount_no_decimals_with_comma_separator: withThousands(noDecimals, '.'),
      amount_with_apostrophe_separator: withThousands(twoDecimals, "'")
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/g, function (match, token) {
      return replacements[token] !== undefined ? replacements[token] : match;
    });
  }

  function HeartEditorial(root) {
    this.root = root;
    this.sectionId = root.closest('[id^="shopify-section-"]').id.replace('shopify-section-', '');
    this.config = (window.__tmrHeartEditorialConfig || {})[this.sectionId] || {};
    this.boxShapeTag = root.getAttribute('data-box-shape-tag') || '';
    this.flowerLabelEl = root.querySelector('[data-heart-variant-label="flower"]');
    this.boxLabelEl = root.querySelector('[data-heart-variant-label="box"]');
    this.currentFlower = norm(this.flowerLabelEl.textContent);
    this.currentBox = norm(this.boxLabelEl.textContent);
    this.flowerLabelEl.setAttribute('data-selected-value', this.currentFlower);
    this.boxLabelEl.setAttribute('data-selected-value', this.currentBox);
    this.currentSoldOut = root.getAttribute('data-available') === 'false';
    this.gallery = root.querySelector('[data-heart-gallery]');
    this.galleryTrack = root.querySelector('[data-heart-gallery-track]');
    this.galleryDots = root.querySelector('[data-heart-gallery-dots]');
    this.prevBtn = root.querySelector('[data-heart-gallery-prev]');
    this.nextBtn = root.querySelector('[data-heart-gallery-next]');
    this.titleLink = root.querySelector('[data-heart-title-link]');
    this.priceEl = root.querySelector('[data-heart-price]');
    this.flowerContainer = root.querySelector('[data-heart-swatches="flower"]');
    this.boxContainer = root.querySelector('[data-heart-swatches="box"]');
    this.formId = this.config.formId;
    this._hoverTimer = null;
    this._previewCache = new Map();

    this.init();
  }

  HeartEditorial.prototype.init = function () {
    if (!this.boxShapeTag || !this.config.storefrontToken) {
      if (this.flowerContainer) this.flowerContainer.innerHTML = '';
      if (this.boxContainer) this.boxContainer.innerHTML = '';
      return;
    }
    this.fetchVariants().then(
      function (products) {
        this.allProducts = products;
        this.renderBothSwatchRows();
        this.bindInteractions();
      }.bind(this)
    );
  };

  HeartEditorial.prototype.renderBothSwatchRows = function () {
    var processed = this.processVariants(this.allProducts || []);
    this.renderSwatches(processed.flowerVariants, 'flower', this.flowerContainer);
    this.preloadVariantImages(processed.flowerVariants, 'flower');
    this.renderSwatches(processed.boxVariants, 'box', this.boxContainer);
    this.preloadVariantImages(processed.boxVariants, 'box');
    this.updateGallerySoldOutBadge(this.currentSoldOut);
  };

  HeartEditorial.prototype.preloadPreview = function (url) {
    if (!url) return Promise.resolve();
    if (this._previewCache.has(url)) return this._previewCache.get(url);
    var p = new Promise(function (resolve) {
      var im = new Image();
      im.decoding = 'async';
      im.onload = im.onerror = function () {
        resolve();
      };
      im.src = url;
    });
    this._previewCache.set(url, p);
    return p;
  };

  HeartEditorial.prototype.preloadVariantImages = function (variants, type) {
    var self = this;
    (variants || []).forEach(function (variant) {
      var thumb = type === 'flower' ? variant.flowerImg : variant.boxImg;
      var previewUrl = variant.bigImg || thumb;
      if (previewUrl) self.preloadPreview(previewUrl);
    });
  };

  HeartEditorial.prototype.fetchVariants = function () {
    var query =
      'query GetVariants($tag: String!) {' +
      '  products(first: 150, query: $tag) {' +
      '    edges {' +
      '      node {' +
      '        tags' +
      '        handle' +
      '        title' +
      '        availableForSale' +
      '        featuredImage { url }' +
      '        media(first: 10) { edges { node { ... on MediaImage { image { url } } } } }' +
      '        flowerImage: metafield(key: "stc_flower_image", namespace: "custom") { value }' +
      '        boxImage: metafield(key: "stc_box_image", namespace: "custom") { value }' +
      '        flowerName: metafield(key: "stc_flower_name", namespace: "custom") { value }' +
      '        boxColor: metafield(key: "stc_box_color", namespace: "custom") { value }' +
      '        priceRange { minVariantPrice { amount } }' +
      '        variants(first: 1) { edges { node { id } } }' +
      '      }' +
      '    }' +
      '  }' +
      '}';

    var headers = {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': this.config.storefrontToken
    };
    var boxShapeTag = this.boxShapeTag;

    return fetch('https://' + this.config.shopDomain + '/api/unstable/graphql.json', {
      method: 'POST',
      headers: headers,
      body: JSON.stringify({ query: query, variables: { tag: 'tag:' + boxShapeTag } })
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (result) {
        var edges = (result.data && result.data.products && result.data.products.edges) || [];
        return edges
          .map(function (edge) {
            return edge.node;
          })
          .filter(function (node) {
            return (
              node.tags &&
              node.tags.indexOf(boxShapeTag) !== -1 &&
              node.boxColor &&
              node.boxColor.value &&
              node.flowerName &&
              node.flowerName.value
            );
          });
      })
      .catch(function () {
        return [];
      });
  };

  HeartEditorial.prototype.processVariants = function (products) {
    var self = this;
    var flowerByName = new Map();
    var boxByColor = new Map();

    products.forEach(function (node) {
      var boxColor = norm(node.boxColor.value);
      var flowerName = norm(node.flowerName.value);
      var variantEdge = node.variants && node.variants.edges && node.variants.edges[0];
      var variantGid = variantEdge ? variantEdge.node.id : null;
      var variantId = variantGid ? variantGid.split('/').pop() : null;
      var price = node.priceRange && node.priceRange.minVariantPrice ? node.priceRange.minVariantPrice.amount : null;
      var bigImg = node.featuredImage ? node.featuredImage.url : '';
      var mediaEdges = (node.media && node.media.edges) || [];
      var images = mediaEdges
        .map(function (edge) {
          return edge.node && edge.node.image ? edge.node.image.url : null;
        })
        .filter(Boolean);
      if (images.length === 0 && bigImg) images = [bigImg];

      var entry = {
        handle: node.handle,
        title: node.title,
        availableForSale: node.availableForSale,
        url: '/products/' + node.handle,
        bigImg: bigImg,
        images: images,
        flowerImg: node.flowerImage ? node.flowerImage.value : '',
        boxImg: node.boxImage ? node.boxImage.value : '',
        flowerName: flowerName,
        boxColor: boxColor,
        variantId: variantId,
        price: price
      };

      if (boxColor === self.currentBox) {
        flowerByName.set(flowerName, preferVariant(flowerByName.get(flowerName), entry));
      }
      if (flowerName === self.currentFlower) {
        boxByColor.set(boxColor, preferVariant(boxByColor.get(boxColor), entry));
      }
    });

    return {
      flowerVariants: inMasterOrder(flowerByName, self.config.masterRoseOrder || []),
      boxVariants: inMasterOrder(boxByColor, self.config.masterBoxOrder || [])
    };
  };

  HeartEditorial.prototype.renderSwatches = function (variants, type, container) {
    if (!container) return;
    var self = this;
    container.innerHTML = variants
      .map(function (variant) {
        if (variant.availableForSale === false) return '';
        var isSelected =
          type === 'flower' ? variant.flowerName === self.currentFlower : variant.boxColor === self.currentBox;
        var label = type === 'flower' ? variant.flowerName : variant.boxColor;
        var thumb = type === 'flower' ? variant.flowerImg : variant.boxImg;
        if (!thumb) return '';

        var safeLabel = escapeHtml(label);
        var safeUrl = escapeHtml(variant.url);
        var safeSwatchIcon = escapeHtml(thumb);
        var previewImage = variant.bigImg || thumb;
        var safePreviewImage = escapeHtml(previewImage);
        var safeImages = escapeHtml(
          JSON.stringify(variant.images && variant.images.length ? variant.images : [previewImage])
        );

        return (
          '<a href="' +
          safeUrl +
          '" class="thumbnail-swatch tmr-thumbnail-swatch' +
          (isSelected ? ' is-selected' : '') +
          '" aria-label="' +
          (type === 'flower' ? 'Flower' : 'Box') +
          ' color: ' +
          safeLabel +
          '" title="' +
          safeLabel +
          '" data-heart-swatch="1" data-swatch-type="' +
          type +
          '" data-swatch-label="' +
          safeLabel +
          '" data-swatch-image="' +
          safePreviewImage +
          '" data-swatch-images="' +
          safeImages +
          '" data-swatch-url="' +
          safeUrl +
          '" data-swatch-title="' +
          escapeHtml(variant.title) +
          '" data-swatch-variant-id="' +
          (variant.variantId || '') +
          '" data-swatch-price="' +
          (variant.price || '') +
          '" data-swatch-handle="' +
          escapeHtml(variant.handle) +
          '" data-swatch-soldout="0"' +
          '><span class="sr-only">' +
          safeLabel +
          '</span><img src="' +
          safeSwatchIcon +
          '" alt="' +
          safeLabel +
          '" width="45" height="45" loading="lazy" class="object-cover"></a>'
        );
      })
      .join('');
  };

  HeartEditorial.prototype.setGalleryImages = function (images, altText, targetUrl) {
    if (!this.galleryTrack || !images || !images.length) return;
    var safeAlt = escapeHtml(altText);
    var safeTargetUrl = escapeHtml(targetUrl || '');
    this.galleryTrack.innerHTML = images
      .map(function (imgUrl, i) {
        return (
          '<div class="the-heart-editorial__gallery-slide' +
          (i === 0 ? ' is-active' : '') +
          '" data-heart-gallery-slide><a href="' +
          safeTargetUrl +
          '" data-heart-gallery-slide-link><img src="' +
          escapeHtml(imgUrl) +
          '" alt="' +
          safeAlt +
          '" loading="' +
          (i === 0 ? 'eager' : 'lazy') +
          '"></a></div>'
        );
      })
      .join('');

    if (this.galleryDots) {
      this.galleryDots.innerHTML = images
        .map(function (url, i) {
          return (
            '<button type="button" class="the-heart-editorial__gallery-dot' +
            (i === 0 ? ' is-active' : '') +
            '" data-heart-gallery-dot data-index="' +
            i +
            '" aria-label="Go to image ' +
            (i + 1) +
            '"></button>'
          );
        })
        .join('');
    }

    var hasMultiple = images.length > 1;
    if (this.prevBtn) this.prevBtn.hidden = !hasMultiple;
    if (this.nextBtn) this.nextBtn.hidden = !hasMultiple;
    if (this.galleryDots) this.galleryDots.hidden = !hasMultiple;

    this.galleryTrack.scrollLeft = 0;

    if (this.gallery) this.gallery.dispatchEvent(new CustomEvent('heart:gallery-rebuilt', { bubbles: true }));
  };

  HeartEditorial.prototype.getActiveSlideImg = function () {
    if (!this.gallery) return null;
    return (
      this.gallery.querySelector('.the-heart-editorial__gallery-slide.is-active img') ||
      this.gallery.querySelector('.the-heart-editorial__gallery-slide img')
    );
  };

  HeartEditorial.prototype.previewImage = function (imageUrl) {
    var img = this.getActiveSlideImg();
    if (!img || !imageUrl) return;

    if (img.dataset.origSrc === undefined) {
      img.dataset.origSrc = img.getAttribute('src') || '';
      img.dataset.origSrcset = img.getAttribute('srcset') || '';
      img.dataset.origSizes = img.getAttribute('sizes') || '';
    }

    if (img.getAttribute('src') === imageUrl) return;

    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.setAttribute('src', imageUrl);
  };

  HeartEditorial.prototype.revertPreview = function () {
    var img = this.getActiveSlideImg();
    if (!img || img.dataset.origSrc === undefined) return;

    img.setAttribute('src', img.dataset.origSrc);
    if (img.dataset.origSrcset) img.setAttribute('srcset', img.dataset.origSrcset);
    if (img.dataset.origSizes) img.setAttribute('sizes', img.dataset.origSizes);
  };

  HeartEditorial.prototype.previewLabel = function (type, label) {
    var labelEl = type === 'flower' ? this.flowerLabelEl : this.boxLabelEl;
    if (labelEl && label) labelEl.textContent = label;
  };

  HeartEditorial.prototype.revertLabels = function () {
    if (this.flowerLabelEl) this.flowerLabelEl.textContent = this.flowerLabelEl.getAttribute('data-selected-value');
    if (this.boxLabelEl) this.boxLabelEl.textContent = this.boxLabelEl.getAttribute('data-selected-value');
  };

  HeartEditorial.prototype.updateGallerySoldOutBadge = function (isSoldOut) {
    if (!this.gallery) return;
    var activeSlide = this.gallery.querySelector('.the-heart-editorial__gallery-slide.is-active');
    if (!activeSlide) return;
    var badge = activeSlide.querySelector('.tmr-gallery-sold-out-badge');
    if (isSoldOut) {
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'tmr-gallery-sold-out-badge badge badge--sold-out';
        badge.textContent = this.config.soldOutBadgeText || 'Sold out';
        activeSlide.appendChild(badge);
      }
      badge.removeAttribute('hidden');
    } else if (badge) {
      badge.setAttribute('hidden', '');
    }
  };

  HeartEditorial.prototype.selectSwatch = function (anchor) {
    var type = anchor.getAttribute('data-swatch-type');
    var label = anchor.getAttribute('data-swatch-label');
    var imageUrl = anchor.getAttribute('data-swatch-image');
    var images = [imageUrl];
    try {
      var parsed = JSON.parse(anchor.getAttribute('data-swatch-images') || '[]');
      if (parsed.length) images = parsed;
    } catch (e) {}
    var url = anchor.getAttribute('data-swatch-url');
    var title = anchor.getAttribute('data-swatch-title');
    var variantId = anchor.getAttribute('data-swatch-variant-id');
    var price = anchor.getAttribute('data-swatch-price');
    var swatchHandle = anchor.getAttribute('data-swatch-handle');
    var isSoldOut = anchor.getAttribute('data-swatch-soldout') === '1';

    if (type === 'flower') this.currentFlower = label;
    else this.currentBox = label;

    this.renderBothSwatchRows();

    var labelEl = this.root.querySelector('[data-heart-variant-label="' + type + '"]');
    if (labelEl) {
      labelEl.textContent = label;
      labelEl.setAttribute('data-selected-value', label);
    }

    this.setGalleryImages(images, title, url);

    if (this.titleLink) {
      this.titleLink.setAttribute('href', url);
      if (title) this.titleLink.textContent = title;
    }

    if (price && this.priceEl) this.priceEl.textContent = formatMoney(price, this.config.moneyFormat);
    // Confirm against the live product JSON in case the GraphQL price didn't resolve.
    if (swatchHandle) this.confirmPriceFromServer(swatchHandle);

    if (this.formId && variantId) {
      var idInput = document.querySelector('#' + this.formId + ' input[name="id"]');
      if (idInput) idInput.value = variantId;
    }

    var atcButton = this.root.querySelector('.buy-buttons button[type="submit"]');
    if (atcButton) {
      if (isSoldOut) {
        atcButton.setAttribute('disabled', 'disabled');
        atcButton.textContent = this.config.soldOutButtonText || 'Sold out';
      } else {
        atcButton.removeAttribute('disabled');
        atcButton.textContent = this.config.addToCartButtonText || 'Add to cart';
      }
    }

    this.currentSoldOut = isSoldOut;
    this.updateGallerySoldOutBadge(isSoldOut);
  };

  // GraphQL's price field can fail to resolve while the rest of the node comes through
  // fine, silently leaving the old swatch's price on screen. Confirm and correct it.
  HeartEditorial.prototype.confirmPriceFromServer = function (handle) {
    var self = this;
    var gen = (this._priceGen = (this._priceGen || 0) + 1);
    fetch('/products/' + handle + '.js')
      .then(function (res) {
        return res.ok ? res.json() : null;
      })
      .then(function (data) {
        if (!data || gen !== self._priceGen || !self.priceEl) return;
        var variants = data.variants || [];
        var variant = variants.filter(function (v) { return v.available; })[0] || variants[0];
        if (!variant || typeof variant.price !== 'number') return;
        var dollars = (variant.price / 100).toFixed(2);
        self.priceEl.textContent = formatMoney(dollars, self.config.moneyFormat);
      })
      .catch(function () {});
  };

  HeartEditorial.prototype.bindInteractions = function () {
    var self = this;
    var supportsHover = window.matchMedia && window.matchMedia('(hover: hover)').matches;

    this.root.addEventListener('click', function (e) {
      var anchor = e.target.closest('[data-heart-swatch="1"]');
      if (!anchor) return;
      e.preventDefault();
      if (anchor.classList.contains('is-selected')) return;
      self.selectSwatch(anchor);
    });

    function onPreview(anchor) {
      if (!anchor) return;
      self._hoverGen = (self._hoverGen || 0) + 1;
      var type = anchor.getAttribute('data-swatch-type');
      var label = anchor.getAttribute('data-swatch-label');
      var isSoldOut = anchor.getAttribute('data-swatch-soldout') === '1';
      if (self._hoverTimer) {
        clearTimeout(self._hoverTimer);
        self._hoverTimer = null;
      }
      if (type && label) self.previewLabel(type, label);
      self.updateGallerySoldOutBadge(isSoldOut);
      if (anchor.classList.contains('is-selected')) return;
      self.previewImage(anchor.getAttribute('data-swatch-image'));
    }

    function onLeave() {
      self._hoverGen = (self._hoverGen || 0) + 1;
      var gen = self._hoverGen;
      self._hoverTimer = setTimeout(function () {
        if (gen !== self._hoverGen) return;
        self.revertPreview();
        self.revertLabels();
        self.updateGallerySoldOutBadge(self.currentSoldOut);
      }, 80);
    }

    if (supportsHover) {
      this.root.addEventListener(
        'mouseover',
        function (e) {
          onPreview(e.target.closest('[data-heart-swatch="1"]'));
        },
        { passive: true }
      );

      this.root.addEventListener(
        'mouseleave',
        function (e) {
          var anchor = e.target.closest && e.target.closest('[data-heart-swatch="1"]');
          if (!anchor) return;
          onLeave();
        },
        { passive: true, capture: true }
      );
    }

    this.root.addEventListener(
      'touchstart',
      function (e) {
        onPreview(e.target.closest && e.target.closest('[data-heart-swatch="1"]'));
      },
      { passive: true }
    );

    this.root.addEventListener(
      'focusin',
      function (e) {
        onPreview(e.target.closest && e.target.closest('[data-heart-swatch="1"]'));
      }
    );

    this.root.addEventListener(
      'focusout',
      function (e) {
        var anchor = e.target.closest && e.target.closest('[data-heart-swatch="1"]');
        if (!anchor) return;
        onLeave();
      }
    );

    if (this.prevBtn) this.prevBtn.addEventListener('click', function () { self.stepGallery(-1); });
    if (this.nextBtn) this.nextBtn.addEventListener('click', function () { self.stepGallery(1); });

    if (this.galleryTrack) {
      var scrollSyncTimer = null;
      this.galleryTrack.addEventListener(
        'scroll',
        function () {
          if (scrollSyncTimer) clearTimeout(scrollSyncTimer);
          scrollSyncTimer = setTimeout(function () {
            var slides = Array.prototype.slice.call(self.galleryTrack.querySelectorAll('[data-heart-gallery-slide]'));
            if (!slides.length) return;
            var trackCenter = self.galleryTrack.scrollLeft + self.galleryTrack.clientWidth / 2;
            var closestIndex = 0;
            var closestDistance = Infinity;
            slides.forEach(function (slide, i) {
              var slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
              var distance = Math.abs(slideCenter - trackCenter);
              if (distance < closestDistance) {
                closestDistance = distance;
                closestIndex = i;
              }
            });
            slides.forEach(function (slide, i) {
              slide.classList.toggle('is-active', i === closestIndex);
            });
            if (self.galleryDots) {
              Array.prototype.slice
                .call(self.galleryDots.querySelectorAll('[data-heart-gallery-dot]'))
                .forEach(function (dot, i) {
                  dot.classList.toggle('is-active', i === closestIndex);
                });
            }
          }, 100);
        },
        { passive: true }
      );
    }

    if (this.galleryDots) {
      this.galleryDots.addEventListener('click', function (e) {
        var dot = e.target.closest('[data-heart-gallery-dot]');
        if (!dot) return;
        self.goToSlide(parseInt(dot.getAttribute('data-index'), 10));
      });
    }
  };

  HeartEditorial.prototype.stepGallery = function (direction) {
    var slides = Array.prototype.slice.call(this.galleryTrack.querySelectorAll('[data-heart-gallery-slide]'));
    if (slides.length < 2) return;
    var currentIndex = slides.findIndex(function (s) { return s.classList.contains('is-active'); });
    var nextIndex = (currentIndex + direction + slides.length) % slides.length;
    this.goToSlide(nextIndex);
  };

  HeartEditorial.prototype.goToSlide = function (index, instant) {
    var slides = Array.prototype.slice.call(this.galleryTrack.querySelectorAll('[data-heart-gallery-slide]'));
    var dots = this.galleryDots
      ? Array.prototype.slice.call(this.galleryDots.querySelectorAll('[data-heart-gallery-dot]'))
      : [];
    slides.forEach(function (slide, i) {
      slide.classList.toggle('is-active', i === index);
    });
    dots.forEach(function (dot, i) {
      dot.classList.toggle('is-active', i === index);
    });
    var target = slides[index];
    if (target && target.scrollIntoView) {
      target.scrollIntoView({ behavior: instant ? 'instant' : 'smooth', inline: 'center', block: 'nearest' });
    }
  };

  function init() {
    document.querySelectorAll('[data-heart-editorial]').forEach(function (root) {
      if (root.dataset.heartInit) return;
      root.dataset.heartInit = '1';
      new HeartEditorial(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
